module.exports = __webpack_public_path__ + "static/media/icon_consumidor_final_active.aa8231f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_consumidor_final_active.svg
// module id = 620
// module chunks = 0